module.exports = __webpack_public_path__ + "img/team3.43455c26.png";